import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=de44dc34&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vincent/Documents/Développement/Stadia Fr/Jeux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de44dc34')) {
      api.createRecord('de44dc34', component.options)
    } else {
      api.reload('de44dc34', component.options)
    }
    module.hot.accept("./Logout.vue?vue&type=template&id=de44dc34&", function () {
      api.rerender('de44dc34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/javascripts/pages/site/Logout.vue"
export default component.exports